/* istanbul ignore file */

export enum ControlTypes {
    Columns = 'Columns',
    Fields = 'Fields',
    FieldType = 'FieldType',
    Sections = 'Sections',
    Type = 'type',
}
